module.exports = __webpack_public_path__ + "static/media/Line-Up_Review_Paciente_7.62a86725.jpeg";